import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-duration",
  "use": "icon-duration-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-duration\">\n  <path fill=\"currentColor\" d=\"M10 4a6 6 0 100 12c3.315 0 6-2.686 6-6s-2.685-6-6-6zm2.571 6.858H9.906c-.473 0-.763-.236-.763-.71V7c0-.474.17-.429.643-.429s.643-.045.643.429v2.571h2.143c.473 0 .428.142.428.616 0 .475.045.671-.429.671z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol